import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../get-base-url';
import { useParams } from 'react-router-dom';
import ResearchMarriageNotificationsShared from '../../research-notifications/research-marriage';
import { BreadcrumbItem } from '../../breadcrumb';

interface ResearchMarriageNotificationsCivilStatusSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const ResearchMarriageNotificationsCivilStatusShared = ({
  scope,
  items,
}: ResearchMarriageNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idCat = params.idCat || undefined;
  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/matrimonio/residenti/registrazione`;
  }, [goBackUrl]);

  return (
    <Fragment>
      <ResearchMarriageNotificationsShared
        goBackUrl={goBackUrl}
        redirectUrl={redirectUrl}
        items={items}
      />
    </Fragment>
  );
};

ResearchMarriageNotificationsCivilStatusShared.displayName =
  'Research Marriage Notifications CivilStatusShared component';

export default ResearchMarriageNotificationsCivilStatusShared;
